import LayoutContent from '../../components/layouts/content2';
import React, { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import DetailProduct from './DetailProduct';
import GameScreen from './game/game';

function Index({ dishs, setShowListProduct, setShowHappy }) {
  const { i18n } = useTranslation();
  const langEng = i18n.language === 'en' ?? false;
  const [menus, setMenus] = useState([]);
  const [dataFood, setDataFood] = useState(false);
  const [showGame, setShowGame] = useState(false);
  const [showDetailProduct, setShowDetailProduct] = useState(false);
  const [dataDish, setDataDish] = useState(false);
  const [grill, setGrill] = useState(false);
  const [ribeye, setRibeye] = useState(false);

  useEffect(() => {
    getData('menu').then((items) => {
      const data = items.value.data;
      setMenus(data);
    });
  }, []);

  useEffect(() => {
    menus.map((item) => {
      if (item.id === 257) {
        setDataFood(item.menus);
      }
    });
  }, [menus]);

  useEffect(() => {
    if (dataFood) {
      dataFood.map((item) => {
        if (item.id === 2811) {
          setGrill(item);
        }
        if (item.id === 2385) {
          setRibeye(item);
        }
      });
    }
  }, [dataFood]);

  return (
    <div
      style={{
        position: 'absolute',
        top: 4,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 9999,
      }}
    >
      <LayoutContent
        setShowGame={setShowGame}
        showBack={true}
        setShowListProduct={setShowListProduct}
        goHome={setShowHappy}
      >
        <div
          style={{
            padding: '0 20px',
            height: 800,
            overflow: 'scroll',
            borderRadius: 20,
          }}
        >
          <div
            onClick={() => {
              // setShowDetailProduct(true);
              //setDataDish({ dish: grill, alldish: dataFood, currentDish: grill })
            }}
          >
            <img
              src={require('./assets/event1.jpeg')}
              style={{
                width: '100%',
                height: 650,
                objectFit: 'contain',
                borderRadius: 20,
                marginBottom: 20,
              }}
            />

            <img
              src={require('./assets/event2.jpeg')}
              style={{
                width: '100%',
                height: 650,
                objectFit: 'contain',
                borderRadius: 20,
                marginBottom: 20,
              }}
            />

            {/* <img
              src={require('./assets/event3.png')}
              style={{
                width: '100%',
                height: 650,
                objectFit: 'contain',
                borderRadius: 20,
                marginBottom: 20,
              }}
            /> */}
          </div>
        </div>
        {showDetailProduct && (
          <DetailProduct
            dishMenu={dataDish}
            setShowListProduct2={setShowDetailProduct}
            setShowDetailProduct={setShowDetailProduct}
          />
        )}

        {showGame && <GameScreen setShowListProduct={setShowGame} />}
      </LayoutContent>
    </div>
  );
}
export default Index;
